import React from 'react'
import { IconButton } from 'rsuite';
import { Icon } from '@rsuite/icons';
import '../../App.css';
import * as faApple from '@fortawesome/free-brands-svg-icons/faApple';

const FaSvgIcon = ({ faIcon, ...rest }) => {
  const { width, height, svgPathData } = faIcon;
  return (
    <svg {...rest} viewBox={`0 0 ${width} ${height}`} width="1.5em" height="1.5em" fill="#FF0436">
      <path d={svgPathData}></path>
    </svg>
  );
};

const AppleMusicButton = ({ items, onPress }) => {

    return <div className="App-spotify-dropdown">
      <IconButton appearance="subtle" icon={<Icon as={FaSvgIcon} faIcon={faApple} />} circle onClick={() => window.open('https://music.apple.com/in/playlist/you/pl.u-8aAVXk6cog05qBJ')}/>
    </div>
}

export default AppleMusicButton